import { createRouter, createWebHashHistory } from 'vue-router';

import { routes } from './routes';

// Singleton router instance. Components should use `useRouter()`/`useRoute()`;
// non-component code (e.g. command-palette plugins) can import this directly.
// Hash history (`#/...`) keeps the URL path constant so path-based ingress
// rules are unaffected — all routing lives in the fragment.
export const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes,
});
